module.exports = require("./hr.js");